import { Breakdown } from "@xola/ui-kit";
import React from "react";
import { LineItem } from "types";
import { getPriceAndQuantity } from "./utils";

export const AdjustmentLineItem = ({ lineItem }: { lineItem: LineItem }) => {
    return (
        <Breakdown.Item
            secondary={getPriceAndQuantity(lineItem)}
            value={lineItem.amount}
            data-testid="adjustment-line-item"
            classNames={{ children: "no-translate", info: "no-translate" }}
        >
            {lineItem.name}
        </Breakdown.Item>
    );
};
